<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import PostalCode from '$lib/PageSections/Forms/PostalCode/PostalCode.svelte';

	import residentialImage from './images/above_sink_installation.jpg?w=500';

	let {
		data = null,
		form = null,
		title = 'Indow For Your Windows',
		backgroundColor = 'blue',
		id = '',
		image = residentialImage,
	} = $props();
</script>

{#snippet circleNumber(num = 0)}
	<div class="shrink-0">
		<span
			class="inline-flex h-15 w-15 items-center justify-center rounded-full border-4 border-white text-[2rem] font-bold text-white"
		>
			{num}
		</span>
	</div>
{/snippet}

<Section {backgroundColor} {id}>
	<h2 class="pb-6">{title}</h2>
	<ol
		class="text-indow-grey-dark mb-10 flex max-w-lg list-none flex-col gap-6 pl-0 leading-5"
	>
		<li class="flex gap-6">
			{@render circleNumber(1)}
			<p class="text-indow-grey-dark">
				<span class="font-bold">Request</span> a Free Estimate. We'll provide you
				with a preliminary estimate based on your basic window dimensions. It's quick
				and easy!
			</p>
		</li>
		<li class="flex gap-6">
			{@render circleNumber(2)}
			<p class="text-indow-grey-dark">
				<span class="font-bold">Measure</span> your windows with our easy-to-use
				laser measurement kit. We'll guide you through the simple process, ensuring
				a perfect fit.
			</p>
		</li>
		<li class="flex gap-6">
			{@render circleNumber(3)}
			<p class="text-indow-grey-dark">
				<span class="font-bold">Customize</span> your inserts to match your needs
				and your aesthetic, with tubing colors that seamlessly blend into your space.
			</p>
		</li>
		<li class="flex gap-6">
			{@render circleNumber(4)}
			<p class="text-indow-grey-dark">
				<span class="font-bold">Transform</span> your space with custom-crafted inserts
				shipped directly to your home, ready to fit perfectly in your windows.
			</p>
		</li>
	</ol>

	<PostalCode
		{data}
		{form}
		buttonText="GET STARTED"
		buttonTextLead="CONTACT ME ABOUT AN ESTIMATE"
	/>
	{#if image}
		<Image
			src={image}
			loading="lazy"
			class="no-bleed mb-4 max-w-xl rounded-lg shadow-lg"
		/>
	{/if}
	<p class="text-indow-grey-dark max-w-xl text-left">
		We value safety and privacy. We will never share, sell, or rent your data to
		third parties not directly related to your purchase or consideration of our
		products. <a class="text-indow-grey-medium" href="/privacy-policy"
			>Read our full policy here.</a
		>
	</p>
</Section>
